const mapIt = ({
	itRiskFactorID: itRiskFactorId,
	engagementRiskFactorID,
	riskFactorName,
	isRationaleEmpty,
	isRejected,
	rationale,
	rejectionTypeID: rationaleTypeId
}) => ({
	itRiskFactorId,
	engagementRiskFactorID,
	riskFactorName,
	isRationaleEmpty,
	isRejected,
	rationale,
	rationaleTypeId
});

export default (response) => {
	const {itRiskFactors = [], ...data} = response?.data?.[0] ?? {};
	return {
		...data,
		itRiskFactors: itRiskFactors?.map(mapIt) ?? []
	};
};
